import React from 'react';
import styles from './styles.module.scss';
import icSuccess from 'assets/svg/ic_success_V2.svg';
import Modal from '@profile/src/Components/PopupModal_V2';
import Button from '@profile/src/Components/Button_V2';

const TransactionSuccessModal = ({
  onClose,
  desc
}) => {
  return /*#__PURE__*/React.createElement(Modal, {
    onClose: onClose
  }, /*#__PURE__*/React.createElement("img", {
    src: icSuccess,
    className: styles.img
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "success!"), /*#__PURE__*/React.createElement("span", {
    className: styles.desc
  }, desc), /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    className: styles.btn,
    title: "Awesome!"
  }));
};

export default TransactionSuccessModal;